






























import Vue from "vue";
import ProjectsList from "@/components/ProjectsList.vue";
import ProjectData, { ProjectTag } from "@/data/ProjectData.ts";
import { allProjects, allOrder, tabOverrides, moreWorkIds, moreWorkTabs } from "@/data/ProjectsData.ts";

const tabs = [
  { id: "all", label: "All" },
  { id: "games", label: "Games" },
  { id: "vr", label: "VR" },
  { id: "serious-games", label: "Serious Games" },
  { id: "event-activations", label: "Event Activations" },
  { id: "tools-sdks", label: "Tools & SDKs" },
];

export default Vue.extend({
  name: "Projects",
  components: { ProjectsList },
  data() {
    return {
      activeTab: "all" as string,
      showMore: false,
      tabs,
    };
  },
  computed: {
    projectsById(): Record<string, ProjectData> {
      const map: Record<string, ProjectData> = {};
      for (const p of allProjects) map[p.id] = p;
      return map;
    },
    filteredProjects(): ProjectData[] {
      // A tab follows the "all" ranking filtered by tag, unless it declares its own.
      const all = this.resolveProjects(allOrder);
      if (this.activeTab === "all") return all;
      const override = tabOverrides[this.activeTab];
      if (override) return this.resolveProjects(override);
      return all.filter((p) => p.tags.indexOf(this.activeTab as ProjectTag) !== -1);
    },
    foldsMoreWork(): boolean {
      return moreWorkTabs.indexOf(this.activeTab) !== -1;
    },
    mainProjects(): ProjectData[] {
      if (!this.foldsMoreWork) return this.filteredProjects;
      return this.filteredProjects.filter((p) => moreWorkIds.indexOf(p.id) === -1);
    },
    moreProjects(): ProjectData[] {
      if (!this.foldsMoreWork) return [];
      return this.filteredProjects.filter((p) => moreWorkIds.indexOf(p.id) !== -1);
    },
  },
  methods: {
    selectTab(id: string) {
      this.activeTab = id;
      this.showMore = false;
    },
    resolveProjects(ids: string[]): ProjectData[] {
      return ids
        .map((id) => this.projectsById[id])
        .filter((p): p is ProjectData => !!p);
    },
  },
});
